<template>
  <md-card class="md-layout-item md-size-50 md-layout--goal">
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <h4 class="title" style="height: 26px">
        
      </h4>
    </md-card-header>

    <md-card-content>
      <div class="md-layout-item md-layout" style="border-radius: 4px; background: #f3f3f3;
">
        <h4 class="md-subheading md-layout-item md-size-30" style="display: flex; align-items: center;">
        {{$t("games.goal.title")}}
        </h4>
        <md-field class="md-layout-item md-size-30">
          <label>{{$t("games.goal.scoreLocal")}}</label>
          <md-input type="number" v-model="score.local"></md-input>
        </md-field>
        <div class="md-layout-item md-size-5 divider">
          -
        </div>
        <md-field class="md-layout-item md-size-30">
          <label>{{$t("games.goal.scoreVisitor")}}</label>
          <md-input type="number" v-model="score.visitor"></md-input>
        </md-field>
      </div>
      <h4 class="md-caption">{{$t("games.goal.setScoreTitle")}}</h4>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-layout">
          <md-button class="md-layout-item md-success md-size-100" @click="goal(game.local.id, true)">{{$t("games.goal.goal")}} {{game.local.name}}</md-button>
          <md-button class="md-layout-item md-success md-size-100" @click="goal(game.visitor.id, false)">{{$t("games.goal.goal")}} {{game.visitor.name}}</md-button>
          <div class="md-layout-item" style="padding:0">
            <md-button class="md-layout-item md-warning md-size-100" @click="setScoreManual()">{{$t("games.goal.setScoreManual")}}</md-button>
            <md-tooltip md-direction="bottom">{{$t("games.goal.setScoreTooltip")}}</md-tooltip>
          </div>
          </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    game: Object,
    gameId: Number,
    score: Object
  },
  methods: {
    async goal(teamId, local) {
      const params = {
        gameId: this.gameId,
        teamId,
        sendAnimation: true
      }
      const response = await this.$store.dispatch('goalSend', params)
      if (response != undefined) {
        if (local) {
          this.score.local = Number(this.score.local) + 1;
          this.$notify({
            message: this.$t(`notifications.game.goal.local`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
        } else {
          this.score.visitor = Number(this.score.visitor) + 1;
          this.$notify({
            message: this.$t(`notifications.game.goal.visitor`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
        }
      } else {
        this.$store.dispatch("openModalError")
      } 
    },
    async setScoreManual() {
      const params = {
        gameId: this.gameId,
        scoreLocal: this.score.local,
        scoreVisitor: this.score.visitor
      }
      const response = await this.$store.dispatch('setScore', params)
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.game.goal.scoreManual`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  }
}
</script>

<style>
 .divider {
    line-height: 58px;
    font-weight: 700;
    font-size: 21px;
 }

   .md-layout--goal {
    box-shadow: none;
    border-radius: 0 8px 8px 0;
  }
</style>